module.exports = __webpack_public_path__ + "img/t1-open-content.1327dfc5.png";